module.exports = __webpack_public_path__ + "img/CNC加工中心1.3bb04d3f.jpg";